/**
 * Copy for the collection screen's SSR templates — the server build has no i18n runtime. Each value must
 * stay byte-identical to its `translations/en-US.json` key, or the text changes on hydration;
 * `collectionStaticCopy.test.ts` is the lock.
 */
export const COLLECTION_LABELS = {
    descriptionPlaceholder: 'Author will add description soon',
    descriptionPlaceholderEditor: 'Add a few words about your collection',
    /** `commonShowMore` */
    showMore: 'Show more',
    /** `commonShowLess` */
    showLess: 'Show less',
    /** `collectionListenNext` */
    listenNext: 'Listen next',
    /** `collectionFromOtherCreators` */
    fromOtherCreators: 'From other creators',
    /** `tryForFreeTextLarge` */
    tryForFreeText: 'Audio hosting, extended storage and much more with audio.com Pro',
    /** `headerTryFree` */
    tryForFreeCta: 'Try for Free',
    /** `collectionPlay` */
    play: 'Play',
    /** `collectionMoreActions` */
    moreActions: 'More actions',
    addRemoveAudio: 'Add/remove',
    /** Hardcoded in the hero, so neither label has an en-US key. */
    showDetails: 'Show Details',
    showLessDetails: 'Show Less',
}
